import { Controller } from "@hotwired/stimulus"

export default class ActionDispatchController extends Controller {
    static values = { event: String }

    dispatch() {
        window.dispatchEvent(new CustomEvent(this.eventValue))
    }
}
